import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {CalendarHeaderComponent} from '@shared/components/calendar-header/calendar-header.component';
import { TranslateContext } from '@shared/pipes/translate.pipe';

@Component({
	selector: 'amd-authority-consip-approve-dialog',
	templateUrl: './authority-consip-approve-dialog.component.html',
	styleUrls: ['./authority-consip-approve-dialog.component.scss']
})
export class AuthorityConsipApproveDialogComponent implements OnInit {

	consipRequestForm: FormGroup;
	calendarHeader: typeof CalendarHeaderComponent = CalendarHeaderComponent;
	required: boolean;
	translateContext: TranslateContext = TranslateContext.AUTHORITY;

	constructor(
		@Inject(MAT_DIALOG_DATA) private data: { required: boolean },
		public dialogRef: MatDialogRef<AuthorityConsipApproveDialogComponent>,
		private formBuilder: FormBuilder) {
		this.required = this.data.required;
	}

	ngOnInit(): void {
		this.consipRequestForm = this.required ?
			this.formBuilder.group({
				oda_number: ['', [Validators.required]],
				oda_date: ['', [Validators.required]]
			}
		):
			this.formBuilder.group({
				oda_number: [''],
				oda_date: ['']
			}
		);
	}

	prepareRequestBody(): void {
		const oda_date: string = this.consipRequestForm.get('oda_date').value ? new Date(this.consipRequestForm.get('oda_date').value).toISOString() : '';
		this.dialogRef.close({
				oda_number: this.consipRequestForm.get('oda_number').value,
				oda_date: oda_date
			}
		);
	}
}
